import { render } from "./DocumentArrowUpIcon.vue?vue&type=template&id=658189f9"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__